const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/2cf1c386-8bf6-4b35-9508-22a3e6aba20d/images/17a40a52cb5a9617d4db98ef89565c9b1178c04c1c477082ca43eed98068840b.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative w-full h-[100vh] min-h-[640px] flex items-end justify-center overflow-hidden"
    >
      <img
        src={HERO_IMG}
        alt="Glenlo Abbey Castle Estate, Galway"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1A1818]/85 via-[#1A1818]/30 to-[#1A1818]/20" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A1818]/40 via-transparent to-transparent" />

      <div className="relative z-10 text-center px-6 pb-28 md:pb-36 max-w-5xl">
        <h1
          data-testid="hero-couple-names"
          className="font-display font-light text-[#FAF9F6] text-6xl sm:text-7xl md:text-8xl lg:text-[8.5rem] leading-[0.95] tracking-tight"
        >
          Michelle
          <span className="block italic font-light text-[#A3C1DA] text-5xl sm:text-6xl md:text-7xl my-2 md:my-3">
            &amp;
          </span>
          Niall
        </h1>

        <div className="divider-ornament mt-10 mb-6 text-[#A3C1DA] [text-shadow:_0_1px_8px_rgba(0,0,0,0.45)]">
          <span className="font-display italic text-xl">Galway</span>
        </div>

        <p
          data-testid="hero-date"
          className="font-body tracking-[0.32em] uppercase text-sm md:text-base text-[#FAF9F6]"
        >
          4<sup className="text-[10px] md:text-xs">th</sup> June &middot; 2027
        </p>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2 text-[#FAF9F6]/70">
        <span className="text-[10px] tracking-luxe uppercase">Scroll</span>
        <div className="w-px h-10 bg-[#FAF9F6]/40 animate-pulse" />
      </div>
    </section>
  );
}
